import { useState, useEffect, useCallback } from "react";
import Footer from "../../components/shared/Footer";
import AttachExhibits from "./components/AttachExhibits";
import AttorneySelect from "../../components/shared/AttorneySelect";
import ExistingEfileSummary from "./components/ExistingEFileSummary";
import { PlayCircleFilled } from "@material-ui/icons";
import * as APIModels from "../../models";

import { useParams } from "react-router-dom";
import {
    SubmissionService,
    eFileService,
} from "../../services/SubmissionService";
import {
    ErrorModal,
    ErrorModalProps,
} from "../../components/shared/modals/ErrorModal";
import { Spinner } from "react-bootstrap";
import React from "react";

export default function Order() {
    const { id } = useParams<{ id: string }>();

    const [eFileUpload, seteFileUpload] = useState(
        null as APIModels.eFile | null
    );
    const [loading, setLoading] = useState(true);

    const [submitLoading, setSubmitLoading] = useState(false);

    const [showErrorModal, setShowErrorModal] = useState(false);

    const onEMClose = () => {
        setErrorProps({ errorMessage: "", onClose: onEMClose });
        setShowErrorModal(false);
    };

    const [errorProps, setErrorProps] = useState({
        errorMessage: "",
        onClose: onEMClose,
    } as ErrorModalProps);

    useEffect(() => {
        console.log({ PROPS: errorProps });
        if (errorProps.errorMessage !== "") {
            setShowErrorModal(true);
        }
    }, [errorProps]);

    useEffect(() => {
        console.log("useEffect: " + id);
        eFileService.get({ id: id }).then(
            (resp) => {
                console.log({ "Submission ID": id, "eFileService.get": resp });
                setLoading(false);
                if (resp.successful && resp.data) {
                    console.log("eFileService.get success ");
                    //show efile success
                    if (eFileUpload === null) {
                        seteFileUpload(resp.data);
                    } else {
                        seteFileUpload({
                            ...resp.data,
                            attorneyID: eFileUpload.attorneyID,
                            attorneyName: eFileUpload.attorneyName,
                        });
                    }
                } else {
                    setErrorProps({
                        errorMessage: resp.errorMessage ?? "",
                        onClose: onEMClose,
                    });
                }
            },
            (error) => {
                setLoading(false);
                setErrorProps({
                    ...errorProps,
                    errorMessage: error.message,
                });
            }
        );
    }, []);

    const onAttorneySelected = (id: string, name: string) => {
        seteFileUpload({ ...eFileUpload, attorneyID: id, attorneyName: name });
        console.log(eFileUpload);
    };

    const onFirmSelected = (id: string, name: string) => {
        seteFileUpload({ ...eFileUpload, attorneyID: id, attorneyName: name });
        console.log(eFileUpload);
    };

    const onSubmit = () => {
        setSubmitLoading(true);

        SubmissionService.uploadOrder({
            id: id,
            body: eFileUpload!,
        })
            .then(
                (resp) => {
                    if (resp.successful && resp.data) {
                        //show efile success
                        console.log("Data: " + resp.data);
                        window.location.href = "/uploads";
                    } else {
                        setErrorProps({
                            errorMessage:
                                resp.errorMessage ??
                                "The selected attorney has not been set up to e-file. Please ensure that the attorney has completed set up. If the problem persists, please contact support.",
                            onClose: onEMClose,
                        });
                    }
                },
                (error) => {
                    setErrorProps({
                        errorMessage: error ?? "",
                        onClose: onEMClose,
                    });
                }
            )
            .then(() => {
                setSubmitLoading(false);
            });
    };

    return (
        <div className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box page-title-box-alt">
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            eFileMadeEasy
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">eFile</a>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        Order
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {showErrorModal && <ErrorModal {...errorProps} />}
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-xl-8">
                                        <div
                                            id="checkout-nav-pills-wizard"
                                            className="twitter-bs-wizard form-wizard-header"
                                        >
                                            <ul className="twitter-bs-wizard-nav mb-2 nav nav-pills nav-justified">
                                                <li className="nav-item">
                                                    <a
                                                        href="#attorney-info"
                                                        className="nav-link active"
                                                        data-bs-toggle="tab"
                                                        data-toggle="tab"
                                                    >
                                                        <span className="number">
                                                            01
                                                        </span>
                                                        <span className="d-none d-sm-inline">
                                                            Attorney
                                                        </span>
                                                    </a>
                                                </li>
                                                <li className="nav-item">
                                                    <a
                                                        href="#summary"
                                                        className="nav-link"
                                                        data-bs-toggle="tab"
                                                        data-toggle="tab"
                                                    >
                                                        <span className="number">
                                                            02
                                                        </span>
                                                        <span className="d-none d-sm-inline">
                                                            Summary
                                                        </span>
                                                    </a>
                                                </li>
                                            </ul>
                                            <div className="tab-content twitter-bs-wizard-tab-content">
                                                <div
                                                    className="tab-pane active"
                                                    id="attorney-info"
                                                >
                                                    <div>
                                                        <h4 className="header-title">
                                                            Attorney Information
                                                        </h4>
                                                        <p className="sub-header">
                                                            Please select the
                                                            attorney filing the
                                                            pleadings.
                                                        </p>
                                                    </div>
                                                    <AttorneySelect
                                                        onAttorneySelected={
                                                            onAttorneySelected
                                                        }
                                                        onFirmSelected={
                                                            onFirmSelected
                                                        }
                                                    />
                                                    <ul className="pager wizard list-inline mt-2">
                                                        <li className="list-inline-item">
                                                            <a
                                                                href="/uploads"
                                                                className="btn btn-secondary"
                                                            >
                                                                <i className="mdi mdi-arrow-left"></i>{" "}
                                                                Back to Upload
                                                            </a>
                                                        </li>
                                                        <li className="next list-inline-item float-end">
                                                            {!eFileUpload?.attorneyID ||
                                                            eFileUpload?.attorneyID ==
                                                                "" ? (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-success disabled"
                                                                    disabled
                                                                >
                                                                    Next
                                                                    <i className="mdi mdi-arrow-right"></i>{" "}
                                                                </button>
                                                            ) : (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-success"
                                                                >
                                                                    Next
                                                                    <i className="mdi mdi-arrow-right"></i>{" "}
                                                                </button>
                                                            )}
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div
                                                    className="tab-pane"
                                                    id="summary"
                                                >
                                                    <div>
                                                        <h4 className="header-title">
                                                            Summary
                                                        </h4>
                                                        <p className="sub-header">
                                                            Review the
                                                            information below
                                                            and verify for
                                                            accuracy.
                                                        </p>
                                                    </div>
                                                    <div>
                                                        {" "}
                                                        <ExistingEfileSummary
                                                            upload={
                                                                eFileUpload ??
                                                                {}
                                                            }
                                                        />
                                                    </div>
                                                    <ul className="pager wizard list-inline mt-2">
                                                        <li className="previous list-inline-item">
                                                            <button
                                                                type="button"
                                                                className="btn btn-secondary"
                                                            >
                                                                <i className="mdi mdi-arrow-left me-1"></i>{" "}
                                                                Back to Attorney
                                                            </button>
                                                        </li>

                                                        <li className="next list-inline-item float-end">
                                                            <button
                                                                onClick={() =>
                                                                    onSubmit()
                                                                }
                                                                className="btn btn-success"
                                                            >
                                                                {submitLoading && (
                                                                    <>
                                                                        <Spinner
                                                                            as="span"
                                                                            animation="border"
                                                                            size="sm"
                                                                            role="status"
                                                                            aria-hidden="true"
                                                                        />
                                                                        &nbsp;
                                                                        Loading...
                                                                    </>
                                                                )}
                                                                {!submitLoading && (
                                                                    <>
                                                                        <PlayCircleFilled />{" "}
                                                                        Submit
                                                                    </>
                                                                )}
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
